import { render } from "./EbtBalanceDisplay.vue?vue&type=template&id=aa3a0848"
import script from "./EbtBalanceDisplay.vue?vue&type=script&lang=js"
export * from "./EbtBalanceDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__